/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { styled } from '@mui/material/styles';
import { MenuItem } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { COLOR } from '@src/styles/color';
import { NEW_SIDEBAR_WIDTH } from '@src/styles/config';

const StyledTitleProduct = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  padding-bottom: 10px;
  padding-left: 16px;

  .icon-btn-tooltip {
    color: ${COLOR.white};
    background: linear-gradient(0deg, #ff3b30 0%, #ff6b00 100%);
    margin-left: 2px;
    border: 2px solid #ffd60a;
    border-radius: 50%;
    padding: 10px;
    position: relative;
  }

  .base-input {
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1;
    font-size: 19px;
    font-weight: 600;
  }

  .icon-container {
    position: relative;
  }

  .small-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${COLOR.primary};
  }
  .lable-create-new {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    color: ${COLOR.indigo.default};
  }
  .icon {
    color: ${COLOR.indigo.default} !important;
  }

  .wallet {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    float: right;
    margin-left: auto;

    .wallet-ads {
      width: ${`${NEW_SIDEBAR_WIDTH - 20}px`};
    }

    .wallet-character {
      display: flex;
      gap: 12px;
      align-items: center;
      width: 100%;

      .icon {
        padding: 10px;
        border-radius: 50%;
        background-color: ${COLOR.primary};
      }
    }

    .hover-wallet-package {
      border-radius: 8px;
      padding-left: 16px;
      padding-right: 16px;
      &:hover {
        background: rgba(30, 22, 78, 0.08);
        cursor: pointer;
      }
    }
  }

  .danger-text {
    color: ${COLOR.red} !important;
  }

  .wallet-package {
    display: flex;
    flex-direction: column;
    text-align: right;
    gap: 4px;

    .characters-wrapper {
      display: flex;
      justify-content: flex-start;
      gap: 4px;
      align-items: center;
      float: right;
      margin-left: auto;
    }

    .lock-icon {
      color: ${COLOR.red};
      cursor: pointer;
    }

    .remain-characters {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: -0.4px;
      color: ${COLOR.darkBlue};
      display: flex;
      align-items: center;
      gap: 4px;
      float: right;
      margin-left: auto;
    }

    .expired-date {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: -0.4px;
      color: ${COLOR.label[80]};
    }
  }
`;

const StyledTooltip = styled(
  ({ className, placement = 'right', useNewDesktopSidebarV2, ...props }) => (
    <Tooltip
      {...props}
      classes={{ popper: className }}
      arrow
      placement={placement}
    />
  ),
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: COLOR.label[80],
    backdropFilter: 'blur(25px)',
    color: COLOR.white,
    borderRadius: '12px',
    fontSize: 14,
    fontWeight: 400,
    padding: '8px 16px',
    textAlign: 'center',
    maxWidth: 500,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: COLOR.label[80],
  },
}));

const PopoverUploadMenuItem = styled(MenuItem)``;

export { StyledTitleProduct, PopoverUploadMenuItem, StyledTooltip };
